import { Action, createReducer, on } from '@ngrx/store';
import { getConfigSuccessAction } from './config.actions';

export interface ConfigState {
    supportEmail: string | null;
}

const initialState: ConfigState = {
    supportEmail: null,
};

const reducer = createReducer(
    initialState,
    on(getConfigSuccessAction, (state, { config }) => ({
        ...state,
        supportEmail: config.supportEmail,
    })),
);

export function configReducer(
    state: ConfigState | undefined,
    action: Action,
): ConfigState {
    return reducer(state, action);
}
